import { MOST_ENGAGED } from "constants/actionTypes";
import { getMostEngagedService } from "modules/Services/MostEngagedService";
import store from "../../../store/index";
import { serializeArticles } from "../WhatsHappeningNow/utils";

export const getMostEngaged = (page: any) => {
  store.dispatch({
    type: MOST_ENGAGED.LOAD,
  });
  getMostEngagedService(page.result_limit, page.result_offset)
    .then((res: any) => {
      store.dispatch({
        type: MOST_ENGAGED.LOAD_SUCCESS,
        payload: serializeArticles(res.data),
      });
    })
    .catch((err: any) => {
      console.log(err);
      store.dispatch({
        type: MOST_ENGAGED.LOAD_FAIL,
      });
    });
};
